import React from 'react';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { Avatar, AvatarFallback, AvatarImage } from '@components/common/Avataar';
import { IoIosArrowDown, IoIosLogOut } from 'react-icons/io';
import { JobTitleIcon } from '@components/customIcons';
import { userManager } from '@providers/userManager';
import { DATA_STORE_KEYS, DataStore } from '@providers/dataStore';

export const UserMenu = React.memo(() => {
    const user = userManager.getUserData();
    const userGData = userManager.getGUserData();

    const handleLogout = React.useCallback(() => {
        [DATA_STORE_KEYS.USER, DATA_STORE_KEYS.USER_EMPLOYEE, DATA_STORE_KEYS.IS_LOGGEDIN, DATA_STORE_KEYS.USER_CURRENT_ROLE, DATA_STORE_KEYS.USER_DATA].forEach(
            key => DataStore.removeItem(key),
        );
        window.location.href = '/';
    }, []);

    return (
        <NavigationMenu.Item>
            <NavigationMenu.Trigger className="page-header__actions__user-info">
                <Avatar>
                    <AvatarImage src={userGData.picture} />
                    <AvatarFallback>{user.displayName.charAt(0)}</AvatarFallback>
                </Avatar>
                <div className="page-header__actions__user-info__details">
                    <div className="page-header__actions__user-info__details__name">
                        <p className="text-[#0B0D11]">{user.displayName}</p>
                        <IoIosArrowDown />
                    </div>
                    <div className="page-header__actions__user-info__details__role">
                        <JobTitleIcon />
                        <p className="page-header__actions__user-info__details__role__text">
                            {user.jobTitle}
                        </p>
                    </div>
                </div>
            </NavigationMenu.Trigger>
            <NavigationMenu.Content className="absolute top-full right-0 min-w-[250px] bg-white rounded-md shadow-md py-4">
                <ul className="List one">
                    <li
                        className="page-header__actions__user-info__profile-dropdown__item"
                        onClick={() => handleLogout()}
                    >
                        <IoIosLogOut /> Logout
                    </li>
                </ul>
            </NavigationMenu.Content>
        </NavigationMenu.Item>
    );
});

UserMenu.displayName = 'UserMenu';
